import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=a2d849d8&scoped=true&"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCard.vue?vue&type=style&index=0&id=a2d849d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d849d8",
  null
  
)

export default component.exports